export default "/_next/static/images/service-maxbone-mobile@2x-9d354975461880a38f5655852e312ef6.jpg";